import type { VoicePrefs } from './contracts';

type Json = Record<string, unknown>;
const object = (value: unknown): Json | null =>
  value && typeof value === 'object' && !Array.isArray(value) ? (value as Json) : null;
const bool = (value: unknown) => value === true;
const number = (value: unknown, fallback: number) =>
  typeof value === 'number' && Number.isFinite(value) ? value : fallback;
function parseWindows(value: unknown, fallback: { endpoint: number }) {
  const windows = object(value);
  return windows ? { endpoint: number(windows.endpoint, fallback.endpoint) } : fallback;
}

export function parseVoicePreferences(
  value: unknown,
  undo: { endpoint: number },
): VoicePrefs | null {
  const prefs = object(value);
  if (!prefs) return null;
  return {
    enabled: bool(prefs.enabled),
    readAloud: bool(prefs.readAloud),
    speakWith: prefs.speakWith === 'screen_reader' ? 'screen_reader' : 'poneva',
    rate: number(prefs.rate, 1),
    undoMs: prefs.undoMs === 'always_ask' ? 'always_ask' : parseWindows(prefs.undoMs, undo),
    endpointDelayMs:
      Number.isInteger(prefs.endpointDelayMs) &&
      Number(prefs.endpointDelayMs) >= 500 &&
      Number(prefs.endpointDelayMs) <= 3000
        ? Number(prefs.endpointDelayMs)
        : 1000,
    spokenApprovals: bool(prefs.spokenApprovals),
    fullDuplex: bool(prefs.fullDuplex),
    spokenLanguage: typeof prefs.spokenLanguage === 'string' ? prefs.spokenLanguage : null,
  };
}
